import { Container, Grid, Section } from '@/components/Core'
import { FormBuilder } from '@/components/Project'
import { Lib } from '@/types'
import { readFragment } from 'gql.tada'
import { memo } from 'react'
import SectionContactFragment from './query'

export interface SectionContactProps {
  data: Lib.FragmentOf<typeof SectionContactFragment>
}

export type SectionContactData = Lib.FragmentOf<
  typeof SectionContactFragment
> & {
  _modelApiKey: 'section_contact'
  __typename: 'SectionContactRecord'
  id: string
}

const SectionContact = ({ data }: SectionContactProps) => {
  const d = readFragment(SectionContactFragment, data)

  return (
    <Section
      className={'py-vertical-main bg-neutral-300'}
      mainWrapper={false}
      sectionName={d?._modelApiKey}
      anim="section-fade-in"
    >
      <Container>
        <Grid>
          <div className="mb-xl col-span-12 lg:col-span-4 lg:col-start-2">
            <h2>{d.title}</h2>
          </div>

          <div className="col-span-12 lg:col-span-10 lg:col-start-2">
            {d?.items &&
              d?.items.map((item, index) => (
                <div
                  key={index}
                  className="pb-lg not-last:mb-lg flex flex-col gap-2 not-last:border-b not-last:border-neutral-500"
                >
                  <h3>{item.title}</h3>
                  {item?.text && (
                    <div
                      className="prose"
                      dangerouslySetInnerHTML={{ __html: item?.text }}
                    ></div>
                  )}
                </div>
              ))}

            {d?.contactForm && <FormBuilder data={data.contactForm!} />}
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default memo(SectionContact)
